<!-- Nested tree -->
<app-tree-group 
  [theme]="theme"
  [graph]="viewGraph$ | async">
</app-tree-group>